<template lang="html">
	<vue100vh
		style="position: fixed; width: -webkit-fill-available !important; overflow: hidden; height: 100vh !important;">
		<div :style="stylechat" v-on:drop="drop" v-on:dragover="allowDrop">
			<!-- ui overlay drop file -->
			 <DropFile v-if="stateDropFile" :stateDropFile="stateDropFile" @closeComponents="closeComponents"></DropFile>

			<!-- ui announce -->
			<Announce v-if="stateAnnounce" :list_announce="list_announce" :tokenuser="tokenuser"
				:statemember="statemember" :tokenroom="tokenroom" @emitMessage="emitMessage"></Announce>

			<v-toolbar class="toolbar-header-user" v-if="statusForward" dense fixed>
				<v-row wrap class="justify-center align-center">
					<p class="HeaderName mb-0">{{ $t('Dialog.forward.selectmessage') }}</p>
				</v-row>
			</v-toolbar>
			<v-toolbar class="toolbar-header-user" v-else dense fixed>
				<!-- <v-btn dark icon @click="backpage()" v-if="backstatus !== 'false'">
							<v-icon class="icon-color fz-30">mdi-chevron-left</v-icon>
					</v-btn> -->
				<v-avatar size="35">
					<img v-if="pictureRoom" :lazy-src="pictureRoom" :src="pictureRoom"
						class="imgProfilechat pictureRoomChat alligator-turtle" />
				</v-avatar>
				<p class="HeaderName text-overflow mb-0" v-if="typeRoom !== 'group'">{{ nameRoom }}</p>
				<p class="HeaderName text-overflow-group mb-0" v-else>{{ nameRoom }}</p>
				<p class="HeaderName mb-0" v-if="typeRoom === 'group'">({{ detailroom.count_member }})</p>
				<v-spacer></v-spacer>
				<v-icon class="icon-color fz-20" v-if="showmenu" @click="showMenuRoom(true)">fa-solid fa-bars</v-icon>
			</v-toolbar>

			<v-row class="ma-2" v-if="progress">
				<v-progress-linear :indeterminate="progress" value="30" color="primary" rounded
					height="6"></v-progress-linear>
			</v-row>
			<v-col class="chat-container" ref="chatContainer" @scroll="onScroll">
				<MessageType :typeRoom="typeRoom" :listchat="listchat" :tokenuser="tokenuser" :statemember="statemember"
					@emitMessage="emitMessage" :room_name="nameRoom" :tokenroom="tokenroom"
					:EmitStatusForward="statusForward" :data_user="data_user" :data_rich_menu="data_rich_menu" :listfriend="listfriend"></MessageType>
			</v-col>
			<div v-if="gotoBtm || gotoReply || paste_status" :class="gotoBtm || gotoReply || paste_status ? 'typer-backmsg-inactive' : 'typer-backmsg'"
				ref="btnBackMsg">
				<v-row class="justify-center align-center">
					<v-col cols="3"></v-col>
					<v-col cols="6" class="justify-center align-center">
						<v-row class="justify-center align-center" v-if="gotoReply">
							<v-btn class="btn-confirm text-transform" small dark @click="goBackMsg(idReplyMsg)">
								<v-icon dark class="fz-18 pr-2">fa-solid fa-arrow-rotate-left</v-icon>
								<span class="text-transform">{{ $t('ChatSide.goBackMsg') }}</span>
							</v-btn>
						</v-row>
						<v-row class="justify-center align-center" v-if="gotoMsg">
							<v-chip
								pill
								close
								@click:close="gotoMsg = false, socketmessage = null"
								@click.native="gotoBtmMsg()"
							>
								<v-avatar left>
									<v-img v-if="new_message.path_pic" :src="new_message.path_pic"></v-img>
									<img v-else-if="new_message.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
									<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
								</v-avatar>
								<p class="mb-0 text-overflow-new-msg" v-if="new_message.typeofmessage === 'message'" v-html="convertMsg(new_message.message)"></p>
								<span v-else-if="new_message.typeofmessage === 'image'">{{ $t('ChatSide.image') }}</span>
								<span v-else-if="new_message.typeofmessage === 'file'">{{ $t('ChatSide.file') }}</span>
								<span v-else-if="new_message.typeofmessage === 'sticker'">{{ $t('ChatSide.sticker') }}</span>
								<span v-else-if="new_message.typeofmessage === 'video'">{{ $t('ChatSide.video') }}</span>
								<span v-else-if="new_message.typeofmessage === 'location'">{{ $t('ChatSide.location') }}</span>
								<span v-else-if="new_message.typeofmessage === 'contact'">{{ $t('ChatSide.contact') }}</span>
								<p v-else-if="new_message.typeofmessage === 'albums_message'" class="mb-0">
									<span v-if="new_message.message === 'addimage_albums'">{{ $t('Dialog.album.headerAddImage') }}</span>
									<span v-else>{{ $t('Dialog.album.headerCreate') }}</span>
								</p>
								<span v-else>{{ $t('ChatSide.newMessage') }}</span>
							</v-chip>
						</v-row>
					</v-col>
					<v-col cols="3">
						<v-row class="justify-end align-center mr-2" v-if="gotoBtm">
							<v-btn dark small color="#2463af" fab @click="scrollToBottom()">
								<v-icon dark class="fz-18">mdi-arrow-down</v-icon>
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</div>
			<div v-if="quick_reply_status" ref="quickReply">
				<ListQuickReply :list_quickreply="list_quickreply" :tokenroom="tokenroom" :tokenuser="tokenuser"
					:data_user="data_user" @emitMessage="emitMessage"></ListQuickReply>
			</div>
			<div v-if="reply_status" ref="previewMessage">
				<ReplyChat :reply_data="reply_data" :listfriend="listfriend" @emitReply="emitReply"></ReplyChat>
			</div>
			<div v-if="paste_status" ref="previewFile">
				<ListPriviewFile :preview_data="preview_data" @emitMessage="emitMessage"></ListPriviewFile>
			</div>
			
			<div ref="messageBox" class="messageBox" v-if="!sheetrichmenu && !statusForward">
				<v-row class="ma-1">
					<ListMenuChat @emitChatMenu="emitChatMenu" :statemember="statemember"
						:stateRichmenu="ListMenuData !== '' && detailroom.data_room[0].type === 'bot'"></ListMenuChat>
					<MessageBox @emitMessageBox="emitMessageBox" :statemember="statemember"
						@emitComponents="emitComponents" :reply_status="reply_status"
						:listfriend="listfriend" :typeRoom="typeRoom" :space_key="space_key" :tokenroom="tokenroom" :emitEmoji="emitEmoji">
					</MessageBox>
				</v-row>
			</div>
			<div :ref="sheetrichmenu ? 'messageBox' : 'typerMenuForward'"
				:class="sheetrichmenu ? checkRowRichMenu(ListMenuData.type_menu) : 'selectMenuBox'" v-else>
				<v-row v-if="sheetrichmenu" justify="start" align="end" style="width: 100%;">
					<v-col cols="12" v-if="showMenu">
						<v-row class="justify-center align-center" v-if="width_layout < 1000">
							<v-col cols="10">
								<Richmenu :type_richmenu="parseInt(ListMenuData.type_menu)" :Richmenudialog="Richmenudialog" :inforrichmenu="ListMenuData.list_menu" @emitrichmenu="emitrichmenu"></Richmenu>
							</v-col>
						</v-row>
						<v-row class="justify-space-around align-end mb-1" v-else :class="parseInt(ListMenuData.type_menu) <= 7 ? 'mt-0' : 'mt-5'" :style="parseInt(ListMenuData.type_menu) <= 7 ? '' : ''">
							<v-col :cols="width_layout < 1000 ? 1 : 4"></v-col>
							<v-col :cols="width_layout < 1000 ? 10 : 4" align="center" class="mt-2">
								<Richmenu :type_richmenu="parseInt(ListMenuData.type_menu)" :Richmenudialog="Richmenudialog" :inforrichmenu="ListMenuData.list_menu" @emitrichmenu="emitrichmenu"></Richmenu>
							</v-col>
							<v-col :cols="width_layout < 1000 ? 1 : 4"></v-col>
						</v-row>

						<!-- test ui -->
						<!-- <Richmenu :type_richmenu="parseInt(ListMenuData.type_menu)" :Richmenudialog="Richmenudialog" :inforrichmenu="ListMenuData.list_menu" @emitrichmenu="emitrichmenu"></Richmenu> -->

					</v-col>
					<v-col cols="12" class="pt-0">
						<v-row class="justify-center align-center">
							<v-col cols="1" align="center" justify="end">
								<v-icon class="typingbox-button" @click="stateRichmenu(false)">fa-solid fa-keyboard</v-icon>
							</v-col>
							<v-col cols="11" class="pl-0 pt-0">
								<v-btn color="white" block @click="showRichMenu(!showMenu)">
									<b class="text-tranfrom">{{ListMenuData.menu_label}}</b>
									<v-icon color="#2463af" class="pl-1" v-if="showMenu">fa-solid fa-caret-down</v-icon>
									<v-icon color="#2463af" class="pl-1" v-else>fa-solid fa-caret-up</v-icon>
							</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row v-else class="align-center justify-space-around">
					<v-col cols="6">
						<v-btn color="#2463af" block outlined
							@click="cancelForward()">{{ $t('AnswerQuestion.cancel') }}</v-btn>
					</v-col>
					<v-col cols="6">
						<v-btn color="#2463af" block dark
							@click="openDialog('forward', selectedForward)">{{ $t('AnswerQuestion.forward') }}
							({{ selectedForward.length }})</v-btn>
					</v-col>
				</v-row>
			</div>
		</div>
		<ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail"
			@closeAlertDialog="closeAlertDialog" />
		<ListContact :ListContactDialog="ListContactDialog" :ListContactDetail="ListContactDetail"
			@emitComponents="emitComponents" @closeComponents="closeComponents"></ListContact>
		<Location :LocationDialog="LocationDialog" :LocationDetail="LocationDetail" @emitComponents="emitComponents"
			@closeComponents="closeComponents"></Location>
		<Sticker v-if="stickerDialog" :startPosCursor="startPosCursor" :endPosCursor="endPosCursor"
			:msgSend="new_msgSend" :stickerDialog="stickerDialog" :stickerDetail="stickerDetail" :tokenuser="tokenuser"
			@emitComponents="emitComponents" @closeComponents="closeComponents"></Sticker>
	</vue100vh>
</template>
<script lang="js">
import { Momenttime, Encode } from '@/services';
import { sync } from 'vuex-pathify';
import vue100vh from 'vue-100vh'
import MessageBox from '@/views/Web/MessageBox.vue';
import ListMenuChat from './MenuChat/ListMenuChat.vue';
import MessageType from './MenuChat/MessageType.vue';
import ReplyChat from './MenuChat/ReplyChat.vue';
import ErrorDialog from '@/components/Alert/Error.vue';
import ListContact from './MenuChat/ListContact.vue';
import Location from './MenuChat/Location.vue';
import Sticker from './MenuChat/Sticker.vue';
import Announce from './MenuChat/ListAnnounce.vue';
import ListQuickReply from './MenuChat/ListQuickReply.vue';
import Richmenu from './MenuChat//Richmenu.vue';
import ListPriviewFile from './MenuChat/ListPreviewFile.vue'
import DropFile from './MenuChat/DropFile.vue'
const states = {
	IDLE: "Idle",
	IN_PROGRESS: "In Progress",
	SUCCEEDED: "Successful",
	CANCELLED: "Cancelled",
};

export default {
	components: {
		vue100vh,
		MessageBox,
		ListMenuChat,
		MessageType,
		ReplyChat,
		ErrorDialog,
		ListContact,
		Location,
		Sticker,
		Announce,
		ListQuickReply,
		Richmenu,
		ListPriviewFile,
		DropFile
	},
	data() {
		return {
			stateAllowDrop: false,
			ListFiles: [],
			stateDropFile: false,
			paste_status: false,
			preview_data: [],
			space_key: ' ',
			listfriend: [],
			showMenu: true,
			quick_reply_status: false,
			stateAnnounce: false,
			stickerDialog: false,
			stickerDetail: {},
			ErrorDialog: false,
			ErrorDialogDetail: {},
			request: null,
			currentState: states.IDLE,
			gotoBtm: false,
			gotoReply: false,
			gotoMsg: false,
			progress: true,
			SendFileOneboxDialog: false,
			SendFileOneboxDetail: {},
			swipe_state: '',
			swipe_index: 0,
			list_announce: [],
			less: false,
			show: false,
			videoOptions: {
				autoplay: true,
				controls: true,
				muted: false
			},
			thumbnail_video: '',
			sources_video: [],
			ListForwardDialog: false,
			ListForwardDetail: [],
			statusForward: false,
			selectedForward: [],
			LocationDetail: '',
			LocationDialog: false,
			ListContactDialog: false,
			ListContactDetail: {},
			focusKey: false,
			selectSticker: true,
			tab: 'tab-1',
			tabemo: 'tab-1',
			// emojiGroups,
			menuChat: false,
			menuChatBottom: false,
			marker: true,
			QrcodeInfor: {},
			dialogQrcodRichMenu: false,
			Richmenudialog: false,
			RichmenuState: false,
			sheetrichmenu: false,
			ListMenuData: {},
			WarningDialog: false,
			WarningDialogDetail: {},
			ErrorDialogDetail: {},
			ErrorDialog: false,
			ListBottomMenu: false,
			ListBottomItem: [],
			InforFriend: {},
			DetailFriendDialog: false,
			NoteChatDialog: false,
			NoteChatDetail: {},
			EditNoteChatDialog: false,
			DetailNoteChatDialog: false,
			NoteDetail: {},
			publicPath: process.env.VUE_APP_BASE_PATH,
			ChatRoomMenu: false,
			showmenu: true,
			dialogWebviewbig_ocr: false,
			Webview_item_ocr: {},
			statusload: true,
			isLoading: false,
			numPages: 1,
			urlpdf: '',
			filenamepdf: '',
			pictureRoom: '',
			nameRoom: '',
			typeRoom: '',
			data_user: {},
			tokenuser: '',
			one_id: '',
			tokenroom: '',
			typeuser: 'user',
			msgSend: '',
			new_msgSend: '',
			profileSelf: 'https://chat-api.one.th/alpine/api/v1/file/1b93a561-ab93-4d90-80eb-ffe0f42afafc.jpg',
			scrollable: {
				'height': 'calc(100vh - 130px) !important'
			},
			emitRows: 4,
			stylechat: {
				"--Chat-Background": "white",
				"--Chat-HeaderColor": "white",
				"--Chat-HeaderBackground": "#2463af",
				"--Chat-HeaderPictureBorderRadius": "6px",
				"--Chat-ChatboxBackgroundOwner": "#34567f",
				"--Chat-ChatboxColorOwner": "white",
				"--Chat-ChatboxBorderOwner": "none",
				"--Chat-ChatboxBorderRadiusOwner": "6px",
				"--Chat-ChatboxColorNotSupportOwner": "#929292",
				"--Chat-ChatboxBackgroundOther": "#efefef",
				"--Chat-ChatboxColorOther": "#615f5f",
				"--Chat-ChatboxBorderOther": "none",
				"--Chat-ChatboxBorderRadiusOther": "6px",
				"--Chat-ChatboxColorNotSupportOther": "#b1b1b1",
				"--Chat-TypingboxBackground": "#2463af",
				"--Chat-TypingboxColor": "white",
				"--Chat-QuickReplyButtonBorder": "#2463af",
				"--Chat-QuickReplyButtonBackground": "white",
				"--Chat-QuickReplyButtonColor": "#2463af",
				"--Chat-Icon-Active": "white",
				"--Chat-ColorCancel": "#f44336",
				// "--Chat-MainFontSize-All": this.$store.getters.mainFontSize,
				// "--Chat-SubFontSize-All": this.$store.getters.subFontSize,
				"--Chat-Height-Typer": "160px",
				"--Chat-Height-selectMenu": "60px",
				"--Chat-Height-RichMenu": "auto",
				"--Chat-Height-RichMenuMini": "auto",
				"--Chat-Container": "100vh - 210px",
				"--Chat-MessageVideoError": "The media could not be loaded",
			},
			list_quickreply: {},
			height100: '100vh',
			detailroom: {},
			listchat: [],
			detailReadmore: {},
			dialogReadmore: false,
			Webview_item: {},
			dialogWebviewbig: false,
			backstatus: '',
			datepicker: false,
			timepicker: false,
			maxdate: '',
			mindate: '',
			maxtime: '',
			mintime: '',
			dateselect: '',
			timeselect: '',
			infodata: '',
			landscape: false,
			ocr_detailItem: {},
			itemdetail_quickreply: {},
			statemember: '',
			checkBrowserInfor: {},
			checkBrowserDialog: false,
			pageCount: 1,
			page: null,
			bot_id_richmenu: '',
			menuSticker: false,
			sticker: [],
			previewMessage: false,
			previewMessageInfor: {},
			reply_data: {},
			reply_status: false,
			temp: [],
			heightChat: 0,
			width_layout: 0,
			startPosCursor: 0,
			endPosCursor: 0,
			data_rich_menu: {},
			new_message: {},
			count_emit: 0,
			emitEmoji: {}
		}
	},
	computed: {
		...sync('*')
	},
	watch: {
		// stateDropFile() {
		// 	this.checkHeightChat()
		// },
		// preview_data () {
		// 	console.log("watch preview_data", this.preview_data);
		// },
 		ListFiles () {
			if (this.ListFiles.length !== 0) {
				this.paste_status = true
				var lengthfile = this.ListFiles.length
			var sizefile = []
			for (var i = 0; i < lengthfile; i++) {
				if (this.ListFiles[i].size !== undefined || this.ListFiles[i].size !== 'undefined') {
				sizefile[i] = this.ListFiles[i].size
				}
				// เช็คขนาดไฟล์ที่ส่งไม่เกิน 100 mb
				if (sizefile[i] / 1024 / 1024 > 100) {
				// เก็บ status file error
				this.ErrorDialogDetail = {
					title: 'Error',
					text: this.$t('Alert.Fail.Chat.maxSizeFile100')
				}
				this.ErrorDialog = true
				this.ListFiles.splice(i, 1)
				}
			}

			if (this.ListFiles.length > 10) {
				this.eventDrop = true
				this.dropFileAlert = true
				var new_arr = this.ListFiles.slice(0, 10) // ตัดรูปที่เกินออก ให้เหลือไม่เกิน 10
				this.ListFiles = new_arr
			}
			// this.checkHeightChat()
			}
		},
		async '$route.params.tokenroom'() {
			// console.log("route chat tokenroom =>", this.$route.params.tokenroom);
			this.progress = true;
			this.listchat = [];
			this.ListMenuData = {};
			this.socketmessage = null
			this.paste_status = false
			this.preview_data = []
			this.ListFiles = []
			this.stateDropFile = false
			// tokenroom เปลี่ยน get ข้อมูล room ใหม่
			// inner width
			this.width_layout = window.innerWidth
			// console.log(`this.width_layout: ${this.width_layout}`)
			this.backstatus = this.$route.query.backstatus
			// console.log(`this.backstatus: ${this.backstatus}`)
			this.tokenroom = this.$route.params.tokenroom
			// var user_profile = JSON.parse(this.$cookie.get('user-profile'))
			var user_profile = ''
			if (JSON.parse(this.$cookie.get('user-profile') == null)) {
				user_profile = JSON.parse(localStorage.getItem('user-profile'))
			} else {
				user_profile = JSON.parse(this.$cookie.get('user-profile'))
			}
			this.data_user = user_profile['account']['profile']
			// console.log('this.data_user: ', this.data_user);
			this.tokenuser = this.data_user.tokenuser
			this.heightChat = this.$vssHeight
			if (this.heightChat) {
				this.height100 = this.heightChat + 'px'
			}
			var announce = this.$cookie.get(this.$route.params.tokenroom)
			// console.log(announce)
			if (announce !== null) {
				this.less = true
			}
			// this.InputFocusCancel()
			this.ListMenuData = "";
			this.RichmenuState = false
			this.sheetrichmenu = false

			await this.getroom()
			await this.getmessageHistory("")
			await this.getreply()
			await this.getListSticker()
			await this.getListAnnonce()
		},
		'$vssHeight'() {
			console.log('$vssHeight: ', this.$vssHeight)
			// alert(this.$vssHeight)
		},
		less() {
			if (this.less) {
				this.$cookie.set(this.$route.params.tokenroom, 'less')
			} else {
				this.$cookie.delete(this.$route.params.tokenroom)
			}
		},
		selectedForward() {
			// console.log(this.selectedForward)
			if (this.selectedForward.length > 5) {
				this.ErrorDialogDetail = {
					title: '',
					text: this.$t('Alert.Fail.Chat.maxMessage')
				}
				this.ErrorDialog = true
				_.pullAt(this.selectedForward, [5])
			}
		},
		socket_switch_richmenu() {
			// console.log(this.socket_switch_richmenu)
			if (this.socket_switch_richmenu.tokenroom === this.$route.params.tokenroom) {
				this.stateRichmenu(true)
			}
		},
		socket_switch_keyboard() {
			// console.log(this.socket_switch_keyboard)
			if (this.socket_switch_keyboard.tokenroom === this.$route.params.tokenroom) {
				this.stateRichmenu(false)
			}
		},
		socket_drop_menu() {
			// console.log("socket_drop_menu", this.socket_drop_menu);
			if (this.socket_drop_menu.tokenroom === this.$route.params.tokenroom) {
				this.showRichMenu(false)
			}
		},
		message_read() {
			// console.log("watch message_read => ", this.message_read);
		},
		menuChat() {
			if (this.menuChat) {
				this.scrollable = {
					'height': 'calc(' + this.height100 + ' - 200px) !important'
				}
			} else {
				// this.InputFocus(this.menuChat)
				// console.log(this.InputFocusCancel())
				if (this.menuSticker) {
					this.scrollable = {
						'height': 'calc(' + this.height100 + ' - 450px) !important'
					}
				} else {
					this.scrollable = {
						'height': 'calc(' + this.height100 + ' - 130px) !important'
					}
				}
			}
		},
		statusForward() {
			// console.log("statusForward", this.statusForward);
			const redBox = this.$refs.messageBox
			if (redBox !== null && redBox !== undefined) {
				if (this.statusForward) {
					this.reply_status = false
					this.paste_status = false
					this.preview_data = []
					redBox.style.height = '60px';
				} else {
					redBox.style.height = '160px !impotant';
				}
			}
			this.checkHeightChat();
		},
		gotoBtm() {
			// console.log("gotoBtm =>", this.gotoBtm);
			this.checkHeightChat();
		},
		reply_status() {
			const redBox = this.$refs.messageBox
			if (redBox !== null && redBox !== undefined) {
				if (this.reply_status) {
					this.paste_status = false
					this.preview_data = []
					// this.reply_status = true
					redBox.style.height = `${redBox.scrollHeight}px`;
					
					if (this.paste_status) {
						this.paste_status = false
					}
					if (this.sheetrichmenu) {
						this.sheetrichmenu = false
					}
				} else {
					redBox.style.height = `${redBox.scrollHeight}px`;
				}
			}
			this.checkHeightChat();
		},
		paste_status() {
			const redBox = this.$refs.messageBox
			if (redBox !== null && redBox !== undefined) {
				if (this.paste_status) {
					// this.reply_status = false
					// this.paste_status = true
					redBox.style.height = `${redBox.scrollHeight}px` //'160px';
				} else {
					redBox.style.height = `${redBox.scrollHeight}px` //'160px';
				}
			}
			this.checkHeightChat();
		},
		sheetrichmenu() {
			// console.log("this.ListMenuData.type_menu", this.ListMenuData.type_menu > '7');
			const redBox = this.$refs.messageBox
			if (redBox !== null && redBox !== undefined) {
				if (this.sheetrichmenu && this.showMenu) {
					if (this.reply_status) {
						this.reply_status = false
					}
					if (this.ListMenuData.type_menu !== undefined) {
						if (parseInt(this.ListMenuData.type_menu) > 7) {
							if (this.width_layout > 1000) {
								redBox.style.height = '200px';
							} else {
								// redBox.style.height = '170px';
								redBox.style.height = 'auto';
								redBox.style['padding-top'] = '20px'
								redBox.style['padding-bottom'] = '20px'
							}
						} else {
							if (this.width_layout > 1000) {
								// redBox.style.height = '305px';
								redBox.style.height = 'auto';
								redBox.style['padding-top'] = '10px'
								redBox.style['padding-bottom'] = '20px'
							} else {
								// redBox.style.height = '235px';
								redBox.style.height = 'auto';
								redBox.style['padding-top'] = '30px'
								redBox.style['padding-bottom'] = '20px'
							}
						}
					}
				} else if (this.sheetrichmenu && !this.showMenu) {
					redBox.style.height = '60px';
				} else {
					redBox.style.height = `${redBox.scrollHeight}px` //'160px';
				}
			}
			this.checkHeightChat();
		},
		socket_close_webview() {
			this.dialogWebviewbig_ocr = false
		},
		dateselect() {
			if (this.dateselect) {
				setTimeout(this.scrollToEnd, 1)
			}
		},
		timeselect() {
			if (this.timeselect) {
				setTimeout(this.scrollToEnd, 1)
			}
		},
		scrollToEnd() {
			// console.log("scrollToEnd");
			this.$nextTick(() => {
				var container = this.$refs.chatContainer
				// console.log("container", container)
				if (container !== undefined) {
					container.scrollTop = container.scrollHeight
				}
			})
		},
		list_quickreply() {
			if (this.list_quickreply !== null) {
				this.quick_reply_status = true
				this.sheetrichmenu = false
			} else {
				this.quick_reply_status = false
			}
			this.checkHeightChat()
		},
		socket_official_template(data) {
			// console.log(data)
			if (data.tokenroom === this.$route.params.tokenroom) {
				// console.log(data)
				var index_target = data.target_index
				var index = _.findIndex(this.listchat, function (o) {
					return o.tokenmessage == data.tokenmessage
				})
				this.listchat[index].element.choice[index_target].disable = '1'
			}
		},
		socket_unsendmessage(data) {
			if (data.tokenroom === this.$route.params.tokenroom) {
				var indexid = _.findIndex(this.listchat, function (o) {
					return o.tokenmessage === data.tokenmessage
				})
				var mentiontokenmessage = this.listchat[indexid].tokenmessage
				var indexmentionmsg = _.findIndex(this.listchat, function (o) {
					return o.file_name === mentiontokenmessage
				})
				if (indexmentionmsg === -1) {
					this.listchat[indexid].typeofmessage = 'unsend_message'
				} else {
					this.listchat[indexid].typeofmessage = 'unsend_message'
					this.listchat[indexmentionmsg].source_message.typeofmessage = 'unsend_message'
				}
			}
		},
		socketmessage(data) {
			// console.log("socketmessage =>", data);
			this.checkHeightChat();
			if (data !== null) {
				if (data.tokenuser !== this.tokenuser) {
					if (data.tokenroom === this.tokenroom) {
						this.gotoMsg = true
						this.new_message = data
					}
				this.axios.post(process.env.VUE_APP_API_alpine + '/v1/user-mark-read', {
					tokenuser: this.tokenuser,
					tokenroom: data.tokenroom
				}).then((response) => { })
			}
			// console.log("socket =>", data);
			this.insertMessage(data, data.tokenmessage)
			}
		},
		socketquickreply(data) {
			// console.log("socketquickreply =>", data)
			if (data.tokenroom === this.$route.params.tokenroom) {
				// console.log(data)
				// this.getreply()
				this.datepicker = false
				this.timepicker = false
				this.maxdate = ''
				this.mindate = ''
				this.maxtime = ''
				this.mintime = ''
				this.dateselect = ''
				this.timeselect = ''
				this.infodata = ''
				this.list_quickreply = data
			}
		},
		socketdisablequickreply(data) {
			if (data.tokenroom === this.$route.params.tokenroom) {
				// console.log(data)
				this.datepicker = false
				this.timepicker = false
				this.maxdate = ''
				this.mindate = ''
				this.maxtime = ''
				this.mintime = ''
				this.dateselect = ''
				this.timeselect = ''
				this.infodata = ''
				this.list_quickreply = null
			}
		},

	},
	async created() {
		console.log("created chat");
		// inner width
		this.width_layout = window.innerWidth
		// console.log(`this.width_layout: ${this.width_layout}`)
		this.backstatus = this.$route.query.backstatus
		// console.log(`this.backstatus: ${this.backstatus}`)
		this.tokenroom = this.$route.params.tokenroom
		var user_profile = ''
		if (JSON.parse(this.$cookie.get('user-profile') == null)) {
			user_profile = JSON.parse(localStorage.getItem('user-profile'))
		} else {
			user_profile = JSON.parse(this.$cookie.get('user-profile'))
		}
		this.data_user = user_profile['account']['profile']
		// console.log('this.data_user: ', this.data_user);
		this.tokenuser = this.data_user.tokenuser
		this.heightChat = this.$vssHeight
		if (this.heightChat) {
			this.height100 = this.heightChat + 'px'
		}
		var announce = this.$cookie.get(this.$route.params.tokenroom)
		// console.log(announce)
		if (announce !== null) {
			this.less = true
		}
		// this.InputFocusCancel()
		await this.getroom()
		await this.getmessageHistory("")
		await this.getreply()
		await this.getListSticker()
		await this.getListAnnonce()
	},
	methods: {
		allowDrop(evt) {
			// alert('allowDrop');
			console.log('allowDrop')
			evt.preventDefault()
			if (this.stateAllowDrop || this.reply_status) {
				this.stateDropFile = false
			} else {
				this.stateDropFile = true
			}
			this.checkHeightChat()
		},
		drop(evt) {
			// alert('drop');
			console.log('evt drop')
			evt.preventDefault()
			if (this.stateAllowDrop || this.reply_status) {
			} else {
				if (this.statemember) {
					this.convertFile(evt.dataTransfer.files)
				}
			}
		},
		convertFile (data) {
			this.stateDropFile = false
			var sizefile = []
			for (var i = 0; i < data.length; i++) {
				sizefile[i] = data[i].size
			}
			for (var i = 0; i < data.length; i++) {
				if (data[i].name !== null) {
				if (_.sum(sizefile) / 1024 / 1024 > 1000) {
					this.ErrorDialogDetail = {
						title: 'Error',
						text: this.$t('Alert.Fail.Chat.maxSizeFile1000')
					}
					this.ErrorDialog = true
				} else {
					this.ListFiles.push({
						name: data[i].name,
						value: URL.createObjectURL(data[i]),
						files: data[i],
						type: data[i].type,
						size: data[i].size
						})
					}
				} else {
				if (_.sum(sizefile) / 1024 / 1024 > 1000) {
					this.ErrorDialogDetail = {
					title: 'Error',
					text: this.$t('Alert.Fail.Chat.maxSizeFile1000')
					}
					this.ErrorDialog = true
				} else {
					this.ListFiles.push({
						name: data[i].name !== undefined ? data[i].name : 'image.png',
						value: URL.createObjectURL(data[i]),
						files: data[i],
						type: data[i].type,
						size: data[i].size
						})
					}
				}
			}
			this.preview_data = this.ListFiles
			this.paste_status = true
			// if (this.reply_status) {
			// 	this.reply_status = false
			// }
			this.checkHeightChat()
		},
		scrollToBottom() {
			const container = this.$refs.chatContainer
			// document.getElementById('scroll-container');
			container.scrollTop = container.scrollHeight;
		},
		convertMsg (msg) {
			msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2; cursor:pointer;">@');
			msg = msg.replace(/<\/tax>/g,'</span>');
			// console.log(msg)
			return msg
		},
		showRichMenu (val) {
			this.showMenu = val
			const redBox = this.$refs.messageBox
			if (redBox !== null && redBox !== undefined) {
				if (!this.showMenu) {
					redBox.style.height = '60px';
				} else {
					if (this.ListMenuData.type_menu !== undefined) {
						if (parseInt(this.ListMenuData.type_menu) > 7) {
							if (this.width_layout > 1000) {
								redBox.style.height = '200px';
							} else {
								// redBox.style.height = '170px';
								redBox.style.height = 'auto';
								redBox.style['padding-top'] = '20px'
								redBox.style['padding-bottom'] = '20px'
							}
						} else {
							if (this.width_layout > 1000) {
								// redBox.style.height = '305px';
								redBox.style.height = 'auto';
								redBox.style['padding-top'] = '10px'
								redBox.style['padding-bottom'] = '20px'
							} else {
								// redBox.style.height = '235px';
								redBox.style.height = 'auto';
								redBox.style['padding-top'] = '30px'
								redBox.style['padding-bottom'] = '20px'
							}
						}
					}
				}
			}
			this.checkHeightChat();
		},
		checkRowRichMenu (type) {
			// console.log("checkRowRichMenu => ", type);
			if (type > '7') {
				return 'richMenuBoxMini';
			} else {
				return 'richMenuBox'
			}
		},
		emitrichmenu (item) {
			this.data_rich_menu = item
		},
		openDialog(type, item) {
			var body = {}
			if (type === 'forward') {
				body.type = type;
				body.value = item
				this.ListContactDetail = body
				this.ListContactDialog = true
			}
		},
		async cancelForward() {
			console.log("cancelForward");
			// this.$emit('emitMessage', { name: 'forward', status: false })
			this.statusForward = false
			await this.getroom()
			this.checkHeightChat()
		},
		closeComponents(item) {
			if (item.name === 'listcontact') {
				this.ListContactDetail = {}
				this.ListContactDialog = item.value
			} else if (item.name === 'sendlocation') {
				this.LocationDetail = ''
				this.LocationDialog = item.value
			} else if (item.name === 'sticker') {
				this.stickerDialog = item.value
				this.stickerDetail = {}
			} else if (item.name === 'forward') {
				this.ListContactDetail = {}
				this.ListContactDialog = item.value
				this.selectedForward = []
				this.statusForward = false
			} else if (item.name === 'dropFile') {
				this.stateDropFile = false
				this.ListFiles = []
			}
		},
		closeAlertDialog(item) {
			// console.log(item)
			if (item.type === 'err') {
				this.ErrorDialog = item.value
			} else if (item.type === 'warning') {
				this.WarningDialog = item.value
			}
		},
		emitChatMenu(value) {
			// console.log("emitChatMenu =>", value);
			if (value.type === 'image' || value.type === 'file') {
				this.sendFileAndImage(value.item);
			} else if (value.type == 'friend') {
				this.ListContactDialog = true;
				this.ListContactDetail.type = 'send-contact';
			} else if (value.type == 'location') {
				this.LocationDetail = '';
				this.LocationDialog = true;
			} else if (value.type == 'sticker') {
				this.stickerDetail = {};
				this.stickerDialog = true;
			} else if (value.type === 'menu') {
				this.sheetrichmenu = true;
			}
		},
		sendFileAndImage(data) {
			// console.log("sendFileAndImage =>", data);
			this.menuChat = false
			this.menuChatBottom = false
			// this.InputFocusCancel()
			let uploadedFiles = data.target.files
			var lengthfile = uploadedFiles.length
			// console.log("lengthfile", lengthfile);
			var sizefile = []
			for (var i = 0; i < lengthfile; i++) {
				sizefile[i] = uploadedFiles[i].size
			}
			if (_.sum(sizefile) / 1024 / 1024 > 100) {
				this.$swal({
					title: this.$t('Alert.Fail.Chat.maxSizeFile100'),
					type: 'warning'
				})
			} else {
				for (let i = 0; i < lengthfile; i++) {
					if (uploadedFiles[i].type === 'image/jpeg' || uploadedFiles[i].type === 'image/png' || uploadedFiles[i].type === 'image/jpg') {
						this.sendFile('image', uploadedFiles[i], process.env.VUE_APP_API_message + '/push_image')
					} else if (this.extension(uploadedFiles[i].name) === 'media') {
						this.sendFile('video', uploadedFiles[i], process.env.VUE_APP_API_media + '/v1/send-video')
					} else {
						this.sendFile('file', uploadedFiles[i], process.env.VUE_APP_API_message + '/push_file')
					}
				}
			}
		},
		updateState(msg) {
			this.currentState = msg;
			this.request = null;
			// console.log(this.currentState)
		},
		reset() {
			this.currentState = states.IDLE;
			this.cancel();
			this.request = null;
		},
		cancel() {
			if (this.request) this.request.cancel();
		},
		async sendFile(type, uploadedFiles, path) {
			// insert ข้อความก่อนที่จะส่ง เพื่อทำ loading
			var index_load = 0;
			var msg_id_loading = btoa(Momenttime.dayjstimestamp()) + this.listchat.length
			// console.log("msg_id_loading => ", msg_id_loading);
			this.insertMessageLoading(type, msg_id_loading, uploadedFiles, 'loading')
			index_load = _.findIndex(this.listchat, function (o) { return o.tokenmessage === msg_id_loading })

			var uploadFile = new FormData()
			uploadFile.append('file', uploadedFiles, uploadedFiles.name)
			uploadFile.append('tokenroom', this.tokenroom)
			uploadFile.append('tokenuser', this.tokenuser)
			uploadFile.append('type', this.typeuser)

			this.updateState(states.IN_PROGRESS);
			this.cancel();
			let axiosSource = this.axios.CancelToken.source();
			this.request = {
				cancel: axiosSource.cancel
			};
			await this.axios.post(path, uploadFile, {
				cancelToken: axiosSource.token,
				onUploadProgress: function (progressEvent) {
					this.listchat[index_load].value_loading = Math.round((progressEvent.loaded * 100) / progressEvent.total);
					// console.log(`${index_load}`, Math.round((progressEvent.loaded * 100) / progressEvent.total));
				}.bind(this),
			}).then((response) => {
				if (response.data.status === 'success') {
					this.updateState(states.SUCCEEDED);
					// ลบข้อความ loading ออก
					index_load = _.findIndex(this.listchat, function (o) { return o.tokenmessage === msg_id_loading })
					if (index_load !== -1) {
						this.listchat.splice(index_load, 1)
					}
					// insert เปลี่ยนมารับจาก socket
					// this.insertMessage(response.data.data, response.data.data.tokenmessage)
				} else {
					// เซตข้อความ loading เป็น error
					if (index_load !== -1) {
						this.listchat[index_load].status_send = 'error';
					}
					this.ErrorDialogDetail = {
						title: 'Error',
						text: response.data.message
					}
					this.ErrorDialog = true
				}
			}, (error) => {
				console.log(error)
				// เซตข้อความ loading เป็น error
				index_load = _.findIndex(this.listchat, function (o) { return o.tokenmessage === msg_id_loading })
				if (index_load !== -1) {
					this.listchat[index_load].status_send = 'error';
				}
				this.ErrorDialogDetail = {
					title: 'Error',
					text: this.$t('Alert.Fail.default.somethingWrong')
				}
				this.ErrorDialog = true
			})
		},
		extension(path) {
			var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
			var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
			var pdf = ['pdf']
			var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm']
			var presentation = ['ppt', 'pps', 'pot', 'pptx']
			var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
			var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
			var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
			var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
			var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
			if (pdf.includes(extension)) {
				return 'fas fa-file-alt'
			} else if (archive.includes(extension)) {
				return 'fas fa-file-archive'
			} else if (spreadsheet.includes(extension)) {
				return 'fas fa-file-excel'
			} else if (presentation.includes(extension)) {
				return 'fas fa-file-powerpoint'
			} else if (word.includes(extension)) {
				return 'fas fa-file-word'
			} else if (execution.includes(extension)) {
				return 'fas fa-file-code'
			} else if (image.includes(extension)) {
				return 'fas fa-file-image'
			} else if (media.includes(extension)) {
				return 'media'
			} else if (audio.includes(extension)) {
				return 'fa-solid fa-file-audio'
			} else {
				return 'fas fa-file-alt'
			}
		},
		emitComponents(item) {
			// console.log("emitComponents =>", item);
			if (item.name === 'sendMsg') {
				this.sendMessage(item.value.data);
				if (this.preview_data.length !== 0) {
					for (let index = 0; index < this.preview_data.length; index++) {
						if (this.preview_data[index].type === 'image/jpeg' || this.preview_data[index].type === 'image/png' || this.preview_data[index].type === 'image/jpg') {
						this.sendFile('image', this.preview_data[index].files, process.env.VUE_APP_API_message + '/push_image')
						} else if (this.extension(this.preview_data[index].name) === 'media') {
							this.sendFile('video', this.preview_data[index].files, process.env.VUE_APP_API_media + '/v1/send-video')
						} else {
							this.sendFile('file', this.preview_data[index].files, process.env.VUE_APP_API_message + '/push_file')
						}
						if (index === this.preview_data.length - 1) {
							this.preview_data = []
							this.paste_status = false
						}
					}
				}
				this.stickerDialog = false
				this.stickerDetail = {}
			} else if (item.name === 'message') {
				this.msgSend = item.value.data
			} else if (item.name === 'append-emoji') {
				this.count_emit += 1
				if (this.count_emit >= 1) {
					this.msgSend = item.value.data
					this.new_msgSend = this.msgSend
					this.emitEmoji = { count: this.count_emit, data: item.value.data }
				}
			} else if (item.name === 'append-sticker') {
				var body = {
					tokenroom: this.tokenroom,
					tokenuser: this.tokenuser,
					message: item.value.data.message,
					type: 'user'
				}
				this.sendSticker(body, item.value.data)
			} else if (item.name === 'replyMsg') {
				this.replyMsg()
			} else if (item.name === 'send-contact') {
				this.ListContactDialog = false;
				this.ListContactDetail = {}
				this.sendContact(item.value.list_friend);
			} else if (item.name === 'send-location') {
				this.LocationDialog = false;
				this.LocationDetail = ''
				this.sendLocation(item.body);
			} else if (item.name === 'on-paste') {
				this.paste_status = true
				this.preview_data = item.value
				this.reply_status = false
			}
		},
		emitReply(data) {
			// console.log("emitReply =>", data);
			this.reply_status = data.value
		},
		emitMessage(data) {
			// console.log("emit Message chat", data);
			this.data_rich_menu = null;
			// console.log("data.methods === 'mention' => ", data.methods === 'mention');
			if (data.methods === 'mention') {
				this.reply_data = data.value;
				this.reply_status = true;
			} else if (data.status_send === 'cancel-upload') {
				// console.log("cancel upload");
				this.listchat[data.index].status_send = 'cancel-upload';
				this.cancel();
				this.updateState(states.CANCELLED);
			} else if (data.status_send === 'delete-msg') {
				this.listchat.splice(data.index, 1)
			} else if (data.status_send === 'resend-msg') {
				this.resendMessage(data)
			} else if (data.methods === 'forward') {
				this.statusForward = data.status;
				this.sheetrichmenu = !data.status;
			} else if (data.methods === 'forward-lenght') {
				this.selectedForward = data.value
			} else if (data.methods === 'announce') {
				this.stateAnnounce = data.value
				this.getListAnnonce()
			} else if (data.methods === 'insertmessage') {
				this.clearQuickreply()
				this.insertMessage(data.value, data.value.tokenmessage)
			} else if (data.methods === 'sendlocation') {
				// this.sendLocation(data.value)
				// อัพเดทชื่อสถานที่ก่อนส่งตำแหน่ง
				this.updatePlaceName(data.value)
			} else if (data.methods === 'send-message') {
				this.sendMessage(data.message)
				if (this.preview_data.length !== 0) {
					for (let index = 0; index < this.preview_data.length; index++) {
						if (this.preview_data[index].type === 'image/jpeg' || this.preview_data[index].type === 'image/png' || this.preview_data[index].type === 'image/jpg') {
						this.sendFile('image', this.preview_data[index].files, process.env.VUE_APP_API_message + '/push_image')
						} else if (this.extension(this.preview_data[index].name) === 'media') {
							this.sendFile('video', this.preview_data[index].files, process.env.VUE_APP_API_media + '/v1/send-video')
						} else {
							this.sendFile('file', this.preview_data[index].files, process.env.VUE_APP_API_message + '/push_file')
						}
						if (index === this.preview_data.length - 1) {
							this.preview_data = []
							this.paste_status = false
						}
					}
				}
			} else if (data.methods === 'clearDataRichMenu') {
				this.data_rich_menu = null
			} else if (data.methods === 'close-preview') {
				this.preview_data = []
				this.paste_status = data.value
			} else if (data.methods === 'update-prview') {
				this.preview_data = data.item
			} else if (data.methods === 'openModal') {
				this.stateAllowDrop = data.value
			}
		},
		updatePlaceName(item) {
		// ใช้ Google Maps Geocoding API
		// const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
		// const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${item.lat},${item.long}&key=${apiKey}`;
		const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
		const language = this.$i18n.locale !== undefined ? this.$i18n.locale : 'th'; // ภาษาไทย
		const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${item.lat},${item.long}&language=${language}&key=${apiKey}`;
		fetch(url)
			.then((response) => response.json())
			.then((data) => {
			if (data.results.length > 0) {
				this.progress = false;
				// console.log("สถานที่:", data.results[0].formatted_address);
				item.address = data.results[0].formatted_address
				this.sendLocation(item)
			} else {
				console.log("ไม่พบข้อมูลสถานที่");
				item.address = "";
				this.sendLocation(item)
			}
			})
			.catch((error) => console.error("Error:", error));
		},
		sendSticker(body, item) {
			// console.log("sendSticker =>", body);
			// console.log("send sticker item", item);
			var msg_id_loading = btoa(Momenttime.dayjstimestamp()) + this.listchat.length
			this.insertMessageLoading('sticker', msg_id_loading, item, 'loading')
			this.axios.post(process.env.VUE_APP_API_message + '/push_sticker', body).then((response) => {
				var messageSendChat = response.data.data
				if (response.data.status === 'success') {
					this.stickerDialog = false
					this.stickerDetail = {}
					this.$nextTick(() => {
						this.gotoMessage(response.data.data.tokenmessage)
					})
					// ส่งข้อความสำเร็จ ลบข้อความ loading ออก
					var me = this
					var index_load = _.findIndex(me.listchat, function (o) { return o.tokenmessage === msg_id_loading })
					if (index_load !== -1) {
						this.listchat.splice(index_load, 1)
					}
					var messageSendChat = response.data.data
					this.insertMessage(messageSendChat, messageSendChat.tokenmessage)
				}
			})
		},
		sendLocation(item) {
			// console.log("sendLocation =>", item);
			// insert ข้อความก่อนที่จะส่ง เพื่อทำ loading
			var msg_id_loading = btoa(Momenttime.dayjstimestamp()) + this.listchat.length
			this.insertMessageLoading('location', msg_id_loading, item, 'loading')
			this.axios.post(process.env.VUE_APP_API_ALPINE + `/api/v1/pushLocation`, item).then((response) => {
				// console.log(response.data)
				if (response.data['status'] === 'success') {
					this.$nextTick(() => {
						this.gotoMessage(response.data.data.tokenmessage)
					})
					// ส่งข้อความสำเร็จ ลบข้อความ loading ออก
					var me = this
					var index_load = _.findIndex(me.listchat, function (o) { return o.tokenmessage === msg_id_loading })
					if (index_load !== -1) {
						this.listchat.splice(index_load, 1)
					}
					this.insertMessage(response.data.data, response.data.data.tokenmessage)
				}
			}).catch(err => {
				this.progress = false
				this.ErrorDialogDetail = {
					title: `Error ${err.response.data.status}`,
					text: this.$t('Alert.Fail.default.somethingWrong')
				}
				this.ErrorDialog = true
			})
		},
		sendContact(item) {
			// console.log("sendContact => ", item);
			// insert ข้อความก่อนที่จะส่ง เพื่อทำ loading
			var msg_id_loading = btoa(Momenttime.dayjstimestamp()) + this.listchat.length
			this.insertMessageLoading('contact', msg_id_loading, item, 'loading')
			this.axios.post(process.env.VUE_APP_API_message + `/push_contact`, {
				tokenroom: this.$route.params.tokenroom,
				tokenuser: this.data_user.tokenuser,
				tokencontact: item.tokenuser,
				type: item.type
			}).then((response) => {
				// console.log(response.data)
				if (response.data.status === 'success') {
					this.$nextTick(() => {
						this.gotoMessage(response.data.data.tokenmessage)
					})
					// ส่งข้อความสำเร็จ ลบข้อความ loading ออก
					var me = this
					var index_load = _.findIndex(me.listchat, function (o) { return o.tokenmessage === msg_id_loading })
					if (index_load !== -1) {
						this.listchat.splice(index_load, 1)
					}
					this.insertMessage(response.data.data, response.data.data.tokenmessage)
				}
			}).catch(err => {
				this.ErrorDialogDetail = {
					title: `Error ${err.response.data.status}`,
					text: this.$t('Alert.Fail.default.somethingWrong')
				}
				this.ErrorDialog = true
			})
		},
		resendMessage(data) {
			// console.log("resendMessage =>", data);
			// ลบข้อความเก่าออก แล้ว resend ข้อความใหม่
			this.listchat.splice(data.index, 1)
			if (data.type_message_origin === 'image' || data.type_message_origin === 'file' || data.type_message_origin === 'video') {
				// this.sendFileAndImage(data.message)
				if (data.message.type === 'image/jpeg' || data.message.type === 'image/png' || data.message.type === 'image/jpg') {
					this.sendFile('image', data.message, process.env.VUE_APP_API_message + '/push_image')
				} else if (this.extension(data.message.name) === 'media') {
					this.sendFile('video', data.message, process.env.VUE_APP_API_media + '/v1/send-video')
				} else {
					this.sendFile('file', data.message, process.env.VUE_APP_API_message + '/push_file')
				}
			} else if (data.type_message_origin === 'message') {
				this.sendMessage(data.message)
			} else if (data.type_message_origin === 'mention_message') {
				this.reply_data.message = data.source_message.message
				this.reply_data.message_reply = data.message
				this.sendReply(data.message)
			} else if (data.type_message_origin === 'contact') {
				this.sendContact(data)
			} else if (data.type_message_origin === 'location') {
				var body = {
					address: data.file_name,
					lat: data.message.split(',')[0],
					long: data.message.split(',')[1],
					tokenroom: data.tokenroom,
					tokenuser: data.tokenuser
				}
				this.sendLocation(body)
			} else if (data.type_message_origin === 'sticker') {
				var body = {
					tokenroom: data.tokenroom,
					tokenuser: data.tokenuser,
					message: data.message,
					type: data.type,
					business_id: null
				}
				data.s3_name = data.file_name
				this.sendSticker(body, data)
			}
		},
		gotoBtmMsg() {
			// console.log("gotoBtmMsg");
			this.$nextTick(() => {
				this.gotoMessage(this.listchat[this.listchat.length - 1].tokenmessage)
			})
		},
		showMenuRoom(value) {
			// console.log("showMenu", value);
			this.$router.push(`/chat-web/menu/${this.tokenroom}/${this.typeRoom}`)
		},
		stateRichmenu(value) {
			this.sheetrichmenu = value
			this.RichmenuState = value
			this.menuChat = false
		},
		sendReply(msg) {
			this.reply_status = false
			// console.log(msg)
			// console.log("this.reply_data => ", this.reply_data);
			// insert ข้อความก่อนที่จะส่ง เพื่อทำ loading
			var msg_id_loading = btoa(Momenttime.dayjstimestamp()) + this.listchat.length
			this.reply_data.message_reply = msg
			this.insertMessageLoading('mention_message', msg_id_loading, this.reply_data, 'loading')

			var body = {
				mention_message: msg,
				tokenroom: this.tokenroom,
				tokenuser: this.tokenuser,
				tokenmessage: this.reply_data.tokenmessage
			}
			if (!this.isBlank(msg) && !this.isEmpty(msg)) {
				this.axios.post(process.env.VUE_APP_API_message + `/mention_message`, body, {
				}).then((response) => {
					if (response.data.status === 'success') {
						// console.log(response.data.data)
						this.reply_data = ''
						this.msgSend = ''
						this.new_msgSend = ''
						// ส่งข้อความสำเร็จ ลบข้อความ loading ออก
						var me = this
						var index_load = _.findIndex(me.listchat, function (o) { return o.tokenmessage === msg_id_loading })
						if (index_load !== -1) {
							this.listchat.splice(index_load, 1)
						}
						this.insertMessage(response.data.data, response.data.data.tokenmessage)
					} else {
						this.ErrorDialogDetail = {
							title: 'Error',
							text: this.$t('Alert.Fail.default.somethingWrong')
						}
						this.ErrorDialog = true
					}
				}).catch(err => {
					console.log(err)
					this.ErrorDialogDetail = {
						title: 'Error',
						text: this.$t('Alert.Fail.default.somethingWrong')
					}
					this.ErrorDialog = true
				})
			}
		},
		insertMessageLoading(type, id, data, status) {
			// console.log(`insertMessageLoading type: ${type} =>`, data);
			var message = ""
			if (type === 'message') {
				message = {
					message: data,
					nickname: this.data_user.nickname,
					path_pic: this.data_user.profilepicture,
					read: [this.tokenuser],
					receive: [],
					timestamp: Momenttime.dayjstimestamp(),
					tokenmessage: id,
					tokenroom: this.tokenroom,
					tokenuser: this.tokenuser,
					type: this.typeuser,
					typeofmessage: type,
					status_send: status,
					type_message_origin: type
				}
			} else if (type === 'image' || type === 'file' || type === 'video') {
				message = {
					message: data,
					nickname: this.data_user.nickname,
					path_pic: this.data_user.profilepicture,
					file_name: data.name,
					read: [this.tokenuser],
					receive: [],
					timestamp: Momenttime.dayjstimestamp(),
					tokenmessage: id,
					tokenroom: this.tokenroom,
					tokenuser: this.tokenuser,
					type: this.typeuser,
					typeofmessage: 'loading',
					status_send: status,
					value_loading: this.list,
					file_size: this.checkFileSize(parseInt(data.size)),
					type_message_origin: type
				}
			} else if (type === 'mention_message') {
				message = {
					message: data.message_reply,
					nickname: this.data_user.nickname,
					path_pic: this.data_user.profilepicture,
					file_name: data.tokenmessage,
					read: [this.tokenuser],
					receive: [],
					timestamp: Momenttime.dayjstimestamp(),
					tokenmessage: id,
					tokenroom: this.tokenroom,
					tokenuser: this.tokenuser,
					type: this.typeuser,
					typeofmessage: type,
					status_send: status,
					source_message: {
						message: data.message,
						typeofmessage: data.typeofmessage,
						owner_source_message: {
							nickname: data.nickname,
							path_pic: data.path_pic
						}
					},
					type_message_origin: type
				}
			} else if (type === 'contact') {
				message = {
					message: data.tokenuser,
					nickname: this.data_user.nickname,
					nickname_contact: data.name !== undefined ? data.name : data.nickname_contact,
					path_pic: this.data_user.profilepicture,
					pic_contact: data.profilepicture !== undefined ? data.profilepicture : data.pic_contact,
					read: [this.tokenuser],
					receive: [],
					timestamp: Momenttime.dayjstimestamp(),
					tokenmessage: id,
					tokenroom: this.tokenroom,
					tokenuser: this.tokenuser,
					type: this.typeuser,
					typeofmessage: type,
					status_send: status,
					type_message_origin: type
				}
			} else if (type === 'location') {
				message = {
					file_name: data.address,
					message: data.address === "" ? `${data.lat},${data.long}` : data.address,
					nickname: this.data_user.nickname,
					path_pic: this.data_user.profilepicture,
					read: [this.tokenuser],
					receive: [],
					timestamp: Momenttime.dayjstimestamp(),
					tokenmessage: id,
					tokenroom: this.tokenroom,
					tokenuser: this.tokenuser,
					type: this.typeuser,
					typeofmessage: type,
					status_send: 'error',
					type_message_origin: type
				}
			} else if (type === 'sticker') {
				message = {
					file_name: data.s3_name,
					message: data.message,
					nickname: this.data_user.nickname,
					path_pic: this.data_user.profilepicture,
					read: [this.tokenuser],
					receive: [],
					timestamp: Momenttime.dayjstimestamp(),
					tokenmessage: id,
					tokenroom: this.tokenroom,
					tokenuser: this.tokenuser,
					type: this.typeuser,
					typeofmessage: type,
					status_send: 'error',
					type_message_origin: type
				}
			}
			this.listchat.push(message)
			this.clearQuickreply()
			this.listchat = _.sortBy(this.listchat, function (dateObj) {
				return new Date(dateObj.timestamp)
			})
			this.listchat = _.unionBy(this.listchat, 'tokenmessage')
			// console.log('listchat insert =>', this.listchat);
		},
		checkFileSize(bytes, decimalPoint) {
			if (bytes !== '' && bytes !== NaN) {
				if (bytes == 0) return '0 Bytes';
				var k = 1000,
					dm = decimalPoint || 2,
					sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
					i = Math.floor(Math.log(bytes) / Math.log(k));
				return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
			}
		},
		sendMessage(data) {
			//กดส่งแป้นพิมพ์ปิด
			// console.log(this.sheetrichmenu)
			this.sheetrichmenu = false
			// this.InputFocusCancel()
			let replaced = data.replace(/(?:\r\n|\r|\n)/g, '<br>')
			if (this.reply_status) {
				this.sendReply(data)
			} else {
				try {
					if (event.keyCode === 13 || event.which === 1) {
						if (event.shiftKey && replaced !== '') {
							this.msgSend.pasteIntoInput(this.msgSend, '<br>')
						} else {
							if (!this.isBlank(data) && !this.isEmpty(data)) {
								// insert ข้อความก่อนที่จะส่ง เพื่อทำ loading
								var msg_id_loading = btoa(Momenttime.dayjstimestamp()) + this.listchat.length
								this.insertMessageLoading('message', msg_id_loading, data, 'error')
								this.axios.post(process.env.VUE_APP_API_alpine + '/v1/pushMessage', {
									tokenroom: this.tokenroom,
									tokenuser: this.tokenuser,
									type: this.typeuser,
									message: data
								}).then((response) => {
									var messageSendChat = response.data.data
									if (response.data.status === 'success') {
										this.msgSend = ''
										this.new_msgSend = ''
										messageSendChat['status'] = 'success'
										// ส่งข้อความสำเร็จ ลบข้อความ loading ออก
										var me = this
										var index_load = _.findIndex(me.listchat, function (o) { return o.tokenmessage === msg_id_loading })
										if (index_load !== -1) {
											this.listchat.splice(index_load, 1)
										}
										this.insertMessage(messageSendChat, messageSendChat.tokenmessage)
										// this.$nextTick(() => {
										// 	this.gotoMessage(messageSendChat.tokenmessage)
										// })
									} else {
										// insert ข้อความก่อนกรณีส่งไม่สำเร็จ
										this.insertMessageLoading('message', msg_id_loading, data, 'error')
										this.msgSend = ''
										setTimeout(this.scrollToEnd, 1)
									}
								}).catch((error) => {
									console.log(error.response);
									// insert ข้อความก่อนกรณีส่งไม่สำเร็จ
									this.insertMessageLoading('message', msg_id_loading, data, 'error')
									this.msgSend = ''
									setTimeout(this.scrollToEnd, 1)
								})
							}
						}
					}
				} catch (e) {
					console.log(e)
				}
			}
		},
		isBlank(str) {
			return (!str || /^\s*$/.test(str))
		},
		isEmpty(str) {
			return (!str || str.length === 0)
		},
		insertMessage (data, tokenmessage) {
			// console.log(data)
			if (data.tokenroom === this.tokenroom) {
				if (_.find(this.listchat, function (o) {
					return o.tokenmessage === tokenmessage
				}) === undefined) {
					if (data !== undefined) {
						this.listchat.push(data)
					}
					// this.clearQuickreply()
					this.listchat = _.sortBy(this.listchat, function (dateObj) {
						return new Date(dateObj.timestamp)
					})
					this.listchat = _.unionBy(this.listchat, 'tokenmessage')
				}
				if (data.tokenuser === this.tokenuser) {
					this.scrollToBottom()
				}
				// setTimeout(this.gotoMessage(tokenmessage), 1)
			}
		},
		clearQuickreply() {
			if (this.list_quickreply !== null) {
				if (this.list_quickreply.timestamp < this.listchat[this.listchat.length - 1].timestamp) {
					this.list_quickreply = null
					this.quick_reply_status = false
				}
			}
		},
		getListAnnonce() {
			var body = {
				tokenroom: this.$route.params.tokenroom,
				tokenuser: this.tokenuser
			}
			this.axios.post(process.env.VUE_APP_API_EVENT + `/v1/user/get_announce_room`, body, {
			}).then((response) => {
				if (response.data.status == 'success') {
					this.list_announce = _.reverse(response.data.data)
					this.stateAnnounce = true;
				} else {
					this.stateAnnounce = false;
				}
			}).catch(err => {
				console.log(err)
				this.ErrorDialogDetail = {
					title: 'Error',
					text: this.$t('Alert.Fail.default.somethingWrong')
				}
				this.ErrorDialog = true
			})
		},
		getListSticker() {
			this.axios.post(process.env.VUE_APP_API_message + '/sticker/gettitleallsticker', { tokenuser: this.tokenuser }).then((responsed) => {
				this.sticker = responsed.data['data']
				// console.log(this.sticker)
			})
		},
		getreply() {
			this.list_quickreply = null
			this.axios.post(process.env.VUE_APP_API_alpine + '/v1/get-quickreply', {
				tokenroom: this.tokenroom,
				tokenuser: this.tokenuser
			}).then((response) => {
				// console.log(response.data)
				if (response.data.status === 'success' && response.data.data != "") {
					this.list_quickreply = response.data.data
					setTimeout(this.scrollToEnd, 1)
				} else {
					this.list_quickreply = null
				}
			})
		},
		async getmessageHistory(time) {
			// if (time === '') {
			// 	this.listchat = []
			// }
			this.temp = this.selectedForward
			this.selectedForward = []
			this.progress = true;
			await this.axios.post(process.env.VUE_APP_API_alpine + '/v1/getdictmessage', {
				tokenroom: this.tokenroom,
				tokenuser: this.tokenuser,
				time_in: time
			}).then((response) => {
				if (response.data['status'] === 'success') {
					this.progress = false;
					var message = response.data.data
					this.listchat.unshift.apply(this.listchat, response.data['data'].reverse())
					if (message.length === 20) {
						this.statusload = true
					} else if (message.length < 20) {
						this.statusload = false
					}
					this.selectedForward = this.temp
					// console.log("time === ''", time === '');
					if (time === '') {
						// setTimeout(this.scrollToEnd, 1)
						this.$nextTick(() => {
							this.gotoMessage(this.listchat[this.listchat.length - 1].tokenmessage)
						})
					} else {
						this.$nextTick(() => {
							this.gotoMessage(message[message.length - 1].tokenmessage)
						})
					}
					// console.log("this.listchat =>", this.listchat)
				} else {
					if (response.data.message === 'not member.') {
						this.$router.push('/chat/not_permission')
					}
				}
			}).catch((error) => {
				console.log(error.response);
				this.progress = false;
				this.listchat = []
			})
		},
		gotoMessage(token) {
			if (token) {
				var myElement = document.getElementById(token)
				if (myElement) {
					myElement.scrollIntoView({
						duration: true,
						behavior: 'smooth',
						block: 'end',
						queue: false,
						specialEasing: null
					})
					window.location.hash = token
				}
			}
		},
		async getroom() {
			const body = {
				tokenuser: this.tokenuser,
				tokenroom: this.tokenroom
			}
			await this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', body).then((response) => {
				if (response.status === 200) {
					// console.log("room =>", response.data);
					this.detailroom = response.data
					this.typeRoom = response.data.type
					var me = this
					this.listfriend = _.filter(response.data.data_room, function(o) { return o.type === 'user' && o.statemember === 'active' && o.tokenuser !== me.tokenuser })
					// console.log("typeRoom =>", this.typeRoom);
					this.statemember = response.data.statemember
					if (this.detailroom.type == 'user') {
						this.pictureRoom = this.detailroom.data_room[0].profilepicture
						if (this.detailroom.data_room[0].type == 'bot') {
							if(this.statemember === 'friend' || this.statemember === 'active') {
								this.getRichmenu(this.detailroom.data_room[0].tokenuser)
							}
						}
						if (!this.pictureRoom && this.detailroom.data_room[0].type == 'bot') {
							this.pictureRoom = `${this.publicPath}/assets/img/default_profile/bot-white.png`
						} else if (!this.pictureRoom && this.detailroom.data_room[0].type == 'user') {
							this.pictureRoom = `${this.publicPath}/assets/img/default_profile/man-white.png`
						}
						this.nameRoom = this.detailroom.data_room[0].name
					} else {
						this.pictureRoom = this.detailroom.picture
						if (!this.pictureRoom) {
							this.pictureRoom = `${this.publicPath}/assets/img/default_profile/group-white.png`
						}
						this.nameRoom = this.detailroom.group_name
						// + "  (" + this.detailroom.count_member + ")"
					}
				}
			})
		},
		async getRichmenu(tokenbot) {
			await this.axios.post(process.env.VUE_APP_API_GO + `/v1/get-richmenu-by-botid`, {
				bot_id: tokenbot
			}).then((response) => {
				if (response.data.status === 'success') {
					this.ListMenuData = response.data.data
					// console.log("this.ListMenuData =>", this.ListMenuData);
					this.bot_id_richmenu = response.data.data.bot_id
					if (this.ListMenuData.default_behavior === '1') {
						this.showMenu = true
						this.sheetrichmenu = true
						this.menuChat = false
					} else {
						this.showMenu = true
						this.sheetrichmenu = false
						this.menuChat = false
					}
					// console.log(this.ListMenuData)
				} else {
					this.ListMenuData = ""
				}
			}).catch(err => {
				console.log(err)
				this.ErrorDialogDetail = {
					title: 'Error',
					text: this.$t('Alert.Fail.default.somethingWrong')
				}
				this.ErrorDialog = true
			})
		},
		onScroll() {
			let scrollValue = this.$refs.chatContainer
			// console.log("scrollValue =>", scrollValue);
			const distanceToBottom = scrollValue.scrollHeight - (scrollValue.scrollTop + scrollValue.clientHeight);
			// console.log('distanceToBottom: ', distanceToBottom > 70);
			if (distanceToBottom > 70) {
				this.gotoBtm = true
				if (this.socketmessage !== null && this.socketmessage.tokenroom === this.tokenroom) {
					this.gotoMsg = true
				}
			} else {
				this.gotoBtm = false
				this.gotoMsg = false
				this.socketmessage = null
			}
			if (scrollValue.scrollTop == 0 && this.isLoading == false && this.listchat.length !== 0) {
				// console.log("onScroll =>", this.listchat[0]['timestamp']);
				this.getmessageHistory(this.listchat[0]['timestamp'])
			}

		},
		async emitMessageBox(data) {
			// console.log("emitMessageBox => ", data);
			// console.log("typerNew => ", this.typerNew);
			const messageBox = this.$refs.messageBox;
			// console.log("messageBox => ", messageBox);
			this.emitRows = data.rows
			if (this.emitRows === data.maxRows) {
				if (messageBox !== undefined) {
					messageBox.style.height = "360px"
				}
				this.typerNew = 340;
				// this.checkHeightChat();
			} else if (this.emitRows === data.minRows) {
				if (messageBox !== undefined) {
					messageBox.style.height = "160px"
				}
				this.typerNew = 160;
				// this.checkHeightChat();
			} else {
				if (messageBox !== undefined) {
					var count_row = [4, 5, 6, 7, 8, 9, 10, 11, 12]
					var count_height = [175, 195, 225, 245, 280, 320, 340, 350, 360]
					var index = _.findIndex(count_row, function (o) { return o === data.rows })
					var height = ""
					// console.log("index height =>", index);
					if (index !== -1) {
						height = count_height[index]
						messageBox.style.height = `${height}px`
						// console.log("messageBox style =>", messageBox.style.height);
					} else {
						messageBox.style.height = `360px`
					}
				}
			}
			this.checkHeightChat();
		},
		checkHeightChat () {
			setTimeout(() => {
				// ดึงขนาดของกล่องข้อความ
				const messageBox = this.$refs.chatContainer;
				// const redBox = this.$refs.messageBox;
				const redBox = this.$refs.messageBox !== null ? this.$refs.messageBox : this.statusForward ? this.$refs.typerMenuForward : this.$refs.richMenuBox;
				const btnBackMsg = this.$refs.btnBackMsg;
				const previewMessage = this.$refs.previewMessage;
				const previewFile = this.$refs.previewFile;
				const quickReply = this.$refs.quickReply;
				const typerMenuForward = this.$refs.typerMenuForward;
				const typerMenuAlbum = this.$refs.typerMenuAlbum;
				const typerMenuDeleteMsg = this.$refs.typerMenuDeleteMsg;
				const typerMenuNote = this.$refs.typerMenuNote;
				const richMenuBox = this.$refs.messageBox;
				// console.log("redBox", redBox);
				if (redBox !== undefined) {
					var bottomBtn = 55;
					// คำนวณความสูงของกล่องข้อความ
					const messageHeight = redBox.scrollHeight + 56; // บวก 56 ความสูงของ toolbar
					if (messageBox !== undefined) {
						// ปรับความสูงของ chat
						if (previewMessage !== undefined) {
							bottomBtn = 30;
							if (this.emitRows === 4) {
								redBox.style.height = `160px`;
							} else {
								redBox.style.height = `${redBox.scrollHeight}px`;
							}
							if (!this.gotoBtm) {
								// messageBox.style.height = `calc(100vh - ${messageHeight + 75}px`;
								messageBox.style.height = `calc(100vh - ${redBox.scrollHeight + 130}px`;
								previewMessage.style.bottom = `${redBox}px`;
							} else {
								// messageBox.style.height = `calc(100vh - ${messageHeight + 85}px`;
								messageBox.style.height = `calc(100vh - ${redBox.scrollHeight + 150}px`;
								previewMessage.style.bottom = `${redBox}px`;
							}
						} else if (previewFile !== undefined) {
							bottomBtn = 30;
							if (this.emitRows === 4) {
								redBox.style.height = `160px`;
							} else {
								// redBox.style.height = `${redBox.scrollHeight + 80}px`;
								redBox.style.height = `${redBox.scrollHeight}px`;
							}
							if (!this.gotoBtm) {
								messageBox.style.height = `calc(100vh - ${redBox.scrollHeight + 230}px`;
								// messageBox.style.height = `calc(100vh - ${messageHeight + 170}px`;
								previewFile.style.bottom = `${redBox + 5}px`;
							} else {
								messageBox.style.height = `calc(100vh - ${redBox.scrollHeight + 230}px`;
								// messageBox.style.height = `calc(100vh - ${messageHeight + 170}px`;
								previewFile.style.bottom = `${redBox}px`;
							}
						} else if (quickReply !== undefined) {
							bottomBtn = 30;
							if (this.emitRows === 4) {
								redBox.style.height = `160px`;
							} else {
								redBox.style.height = `${redBox.scrollHeight}px`;
							}
							if (!this.gotoBtm) {
								messageBox.style.height = `calc(100vh - ${redBox.scrollHeight + 110}px`;
								// messageBox.style.height = `calc(100vh - ${messageHeight + 55}px`;
								quickReply.style.bottom = `${redBox + 5}px`;
							} else {
								messageBox.style.height = `calc(100vh - ${redBox.scrollHeight + 130}px`;
								// messageBox.style.height = `calc(100vh - ${messageHeight + 55}px`;
								quickReply.style.bottom = `${redBox}px`;
							}
						} 
						// else if (richMenuBox !== undefined){
						// 	console.log("richMenuBox");
						// 	redBox.style.height = 'auto !important';
						// 	redBox.style['padding-top'] = '10px'
						// } 
						else {
							// set height message box
							// console.log("object");
							messageBox.style.height = `calc(100vh - ${messageHeight}px`;
							if (this.emitRows === 4 && !this.sheetrichmenu) {
								redBox.style.height = `160px`
							}
						}
					}
					// show btn to bottom
					if (btnBackMsg !== undefined) {
						btnBackMsg.style.position = "relative";
						btnBackMsg.style.bottom = `${bottomBtn}px`;
					}
				} else {
					// show ui forward, shared album, note, deleted msg
					if (typerMenuForward !== undefined || typerMenuAlbum !== undefined ||
						typerMenuDeleteMsg !== undefined || typerMenuNote !== undefined) {
						// console.log("typerMenuForward", this.statusForward);
						typerMenuForward.style.height = '60px';
						// redBox.style.height = '160px'
						bottomBtn = 40;
						if (!this.gotoBtm) {
							// console.log("height 1");
							messageBox.style.height = `calc(100vh - 150px)`;
						} else {
							// console.log("height 2");
							messageBox.style.height = `calc(100vh - 135px)`;
						}
					}
					// show btn to bottom
					if (btnBackMsg !== undefined) {
						btnBackMsg.style.position = "relative";
						btnBackMsg.style.bottom = `${bottomBtn}px`;
					}
				}
			}, 200);
		},
	},
};
</script>
<style lang="css" scoped>
.text-tranfrom {
	text-transform: none;
}
.fz-18 {
	font-size: 18px !important;
}

.typer-backmsg {
	width: 100%;
	z-index: 0;
	position: absolute;
}

.typer-backmsg-inactive {
	width: 100%;
	z-index: 0;
	height: 30px;
}

.typingbox-button {
	font-size: 20px;
	color: var(--Chat-TypingboxColor) !important;
}

.typingbox-button-send {
	color: var(--Chat-TypingboxColor) !important;
	font-size: 20px !important;
	margin: 5px;
}

.fz-16 {
	font-size: 16px !important;
}

.fz-20 {
	font-size: 20px !important;
}

.fz-30 {
	font-size: 30px !important;
}

.icon-color {
	color: var(--Chat-Icon-Active) !important;
}

.text-overflow {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	width: 60vw;
}
.text-overflow-new-msg {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 20vw;
}

.text-overflow-group {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	max-width: 50vw;
}

.alligator-turtle {
	object-fit: cover;
	object-position: 50% 0;
}

.toolbar-header-user {
	height: 64px;
	box-shadow: none !important;
	background: var(--Chat-HeaderBackground) !important;
}

.pictureRoomChat {
	border-radius: var(--Chat-HeaderPictureBorderRadius) !important;
}

.HeaderName {
	color: var(--Chat-HeaderColor) !important;
	margin-left: 10px;
	font-size: 20px;
	font-weight: 600;
}

.imgProfilechat {
	height: 40px;
	vertical-align: middle;
}

.messageBox {
	width: -webkit-fill-available !important;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	bottom: 0;
	height: var(--Chat-Height-Typer);
	background: var(--Chat-TypingboxBackground) !important;
	box-shadow: none;
	justify-content: center;
	padding-left: 10px;
	padding-right: 10px;
	position: fixed;
}

.richMenuBox {
	width: -webkit-fill-available !important;
	box-sizing: border-box;
	display: flex;
	align-items: flex-end;
	bottom: 0;
	height: var(--Chat-Height-RichMenu);
	background: var(--Chat-TypingboxBackground) !important;
	box-shadow: none;
	justify-content: center;
	padding-left: 10px;
	padding-right: 10px;
	padding-bottom: 10px;
	position: fixed;
}
.richMenuBoxMini {
	width: -webkit-fill-available !important;
	box-sizing: border-box;
	display: flex;
	align-items: flex-end;
	bottom: 0;
	height: var(--Chat-Height-RichMenuMini);
	background: var(--Chat-TypingboxBackground) !important;
	box-shadow: none;
	justify-content: center;
	padding-left: 10px;
	padding-right: 10px;
	padding-bottom: 10px;
	position: fixed;
}
.selectMenuBox {
	width: -webkit-fill-available !important;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	bottom: 0;
	height: var(--Chat-Height-selectMenu);
	background: var(--Chat-HeaderColor) !important;
	box-shadow: none;
	justify-content: center;
	padding-left: 10px;
	padding-right: 10px;
	position: fixed;
	border-top-style: solid;
	border-top-width: thin;
	border-top-color: #d9d9d9;
}

.chat-container {
	box-sizing: border-box;
	height: calc(100vh - 210px);
	overflow-y: auto;
	overflow-x: hidden;
	width: 100%;
	padding: 10px 10px;
	background-color: var(--Chat-Background) !important;
	margin-top: 10px !important;
	margin-bottom: 20px !important;
}

.chat-container::-webkit-scrollbar-thumb {
	background: #888 !important;
	border-radius: 10px;
	background-clip: padding-box !important;
}

.chat-container::-webkit-scrollbar {
	width: 6px;
}
</style>